// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-blend-mode: overlay;
  background-size: 300px;
  background-color: #242736;
}

* {
  outline: none;
  font-size: 18px;
  border-radius: 5px;
  width: 300px;
}

.login-form {
  display: flex;
  flex-direction: column;
}
.login-form input {
  height: 40px;
  padding: 0 10px;
  margin-bottom: 10px;
}
.login-form input.is-invalid {
  border: 1px solid red;
}
.login-form button {
  height: 40px;
  border: none;
  background-color: #0078d7;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.login-form .error {
  display: flex;
  align-items: center;
  height: 60px;
  color: #ef9a9a;
}

.form {
  width: 360px;
  height: auto;
  padding: 30px;
  background-color: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,8BAAA;EACA,sBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;AAAJ;AACI;EACI,YAAA;EACA,eAAA;EACA,mBAAA;AACR;AAAQ;EACI,qBAAA;AAEZ;AAgBI;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAdR;AAoBI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAlBR;;AAsBA;EACI,YAAA;EACA,YAAA;EACA,aAAA;EAGA,oCAAA;AArBJ","sourcesContent":[":host {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    // background-image: url(\"/assets/bg.png\");\r\n    background-blend-mode: overlay;\r\n    background-size: 300px;\r\n    background-color: #242736;\r\n}\r\n\r\n* {\r\n    outline: none;\r\n    font-size: 18px;\r\n    border-radius: 5px;\r\n    width: 300px;\r\n}\r\n\r\n.login-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    input {\r\n        height: 40px;\r\n        padding: 0 10px;\r\n        margin-bottom: 10px;\r\n        &.is-invalid {\r\n            border: 1px solid red;\r\n        }\r\n\r\n    }\r\n    // input[type=\"text\"],\r\n    // input[type=\"password\"] {\r\n    //     height: 40px;\r\n    //     padding: 0 10px;\r\n    //     margin-bottom: 10px;\r\n    //     background-color: #41444d;\r\n    //     border: 1px solid #ffffff;\r\n    //     &.is-invalid {\r\n    //         border: 1px solid red;\r\n    //     }\r\n    //     &::placeholder {\r\n    //         color: #ffffff;\r\n    //     }\r\n    // }\r\n    button {\r\n        height: 40px;\r\n        border: none;\r\n        background-color: #0078d7;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        color:#fff;\r\n        // cursor: pointer;\r\n        // &:hover {\r\n        //     background-color: #9E9E9E;\r\n        // }\r\n    }\r\n    .error {\r\n        display: flex;\r\n        align-items: center;\r\n        height: 60px;\r\n        color: #ef9a9a;\r\n    }\r\n}\r\n\r\n.form{\r\n    width:360px;\r\n    height:auto;\r\n    padding:30px;\r\n    // box-shadow: 0 0 10px rgba(1,196,245,0.8);\r\n    // border: 3px solid #01c4f5;\r\n    background-color:rgba(255,255,255,1);  \r\n}\r\n\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
